import React, { useEffect, useState } from 'react';

const ThemeTest = () => {
  const [cssVars, setCssVars] = useState({});
  
  useEffect(() => {
    const updateVars = () => {
      const root = document.documentElement;
      const styles = getComputedStyle(root);
      
      setCssVars({
        primaryColor: styles.getPropertyValue('--primary-color').trim(),
        primaryFontColor: styles.getPropertyValue('--primary-font-color').trim(),
        headerBg: styles.getPropertyValue('--header-footer-bg').trim(),
        headerFont: styles.getPropertyValue('--header-footer-font').trim()
      });
    };
    
    updateVars();
    
    // Actualizar cada 2 segundos para ver cambios en tiempo real
    const interval = setInterval(updateVars, 2000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', margin: '20px' }}>
      <h2>🎨 Theme Diagnostic</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>CSS Variables (Computed):</h3>
        <pre style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px' }}>
          {JSON.stringify(cssVars, null, 2)}
        </pre>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Test Buttons:</h3>
        <button className="btn btn-primary" style={{ marginRight: '10px' }}>
          Primary Button
        </button>
        <button className="btn btn-secondary">
          Secondary Button
        </button>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <h3>Inline Style Test (Direct Variable):</h3>
        <div 
          style={{ 
            backgroundColor: 'var(--primary-color)',
            color: 'var(--primary-font-color)',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '10px'
          }}
        >
          This box uses --primary-color and --primary-font-color directly
        </div>
        
        <div 
          style={{ 
            backgroundColor: 'var(--header-footer-bg)',
            color: 'var(--header-footer-font)',
            padding: '15px',
            borderRadius: '8px'
          }}
        >
          This box uses --header-footer-bg and --header-footer-font directly
        </div>
      </div>
    </div>
  );
};

export default ThemeTest;

